import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import HeadMeta from '../components/HeadMeta';

export default function Forbidden() {
  const { lang, t } = useLanguage();

  return (
    <>
      <HeadMeta 
        title={t('forbiddenPage.title') || '403 - Adgang nægtet'} 
        description={t('forbiddenPage.message') || '403 Forbidden - Adgang nægtet på Captain Hurghada Tours.'}
      />

      <section className="min-h-screen pt-48 pb-20 bg-slate-950 text-white flex items-center justify-center text-center px-4">
        <div className="max-w-md mx-auto space-y-6">
          <div className="w-20 h-20 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 flex items-center justify-center text-3xl mx-auto shadow-xl">
            <i className="fa-solid fa-lock" aria-hidden="true" />
          </div>

          <span className="text-amber-400 font-bold text-sm uppercase tracking-widest block">
            {t('forbiddenPage.badge') || 'Fejl 403'}
          </span>

          <h1 className="font-serif text-3xl sm:text-5xl font-bold tracking-tight">
            {t('forbiddenPage.title')}
          </h1>

          <p className="text-slate-400 text-sm sm:text-base leading-relaxed">
            {t('forbiddenPage.message')}
          </p>

          <div className="pt-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold text-sm transition-colors shadow-md"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>{t('forbiddenPage.homeBtn')}</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
